module.exports = __webpack_public_path__ + "img/downloads-doc.a73decf0.svg";